import * as gochiMenuEventActions from '../actions/GochiMenusEvent';

const initialState = {
  list: []
};

const gochiMenusEvent = (state = initialState, action) => {
  switch (action.type) {
    case gochiMenuEventActions.GET_GOCHI_MENUS_EVENT_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochiMenuEventActions.GET_GOCHI_MENUS_EVENT_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default gochiMenusEvent;
